import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { translations } from '../../../configs/translations'
import { Language } from '../../../context/LanguageContext'
import { UserVehicleStates, VehicleService } from '../../../services/VehicleService'
import './PreviewBottomMenu.css'

export interface PreviewBottomMenuProps {
	vehicleId: number
}

export const PreviewBottomMenu = ({ vehicleId }: PreviewBottomMenuProps) => {

	const [language, setLanguage] = useState<Language>('ru')
	const t = translations[language]

	const [number, setNumber] = useState<number>(0)
	const [state, setState] = useState<UserVehicleStates>('NO_RELATION')

	const navigate = useNavigate()

	useEffect(() => {
		const fetchNumber: () => Promise<number> = async () => {
			if (state === "RESEARCHABLE") {
				return await VehicleService.getVehicleResearchPrice(vehicleId)
			} else if (state === "RESEARCHED") {
				return await VehicleService.getVehiclePrice(vehicleId)
			} else if (state === "BOUGHT") {
				return await VehicleService.getVehicleRaceExperience(vehicleId)
			} else {
				return 0
			}
		}

		fetchNumber()
			.then((data) => {
				setNumber(data)
			})
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})

	}, [state])

	const updateState = () => {
		VehicleService.getUserVehicleState(vehicleId)
			.then(userVehicleState => {
				setState(userVehicleState)
			})
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	useEffect(() => {
		if (vehicleId) updateState()
	}, [vehicleId])

	const handleButtonClick = () => {
		const buySound = new Audio('./sounds/buy.mp3')
		buySound.volume = 0.1

		const runAction: () => Promise<void> = async () => {
			if (state === "RESEARCHABLE") {
				return await VehicleService.researchVehicle(vehicleId)
			} else if (state === "RESEARCHED") {
				return await VehicleService.buyVehicle(vehicleId)
			} else if (state === "BOUGHT") {
				localStorage.setItem('lastVehicleId', String(vehicleId))
				navigate('/main')
				return
			} else {
				return
			}
		}

		runAction()
			.then(() => {
				if (state === "RESEARCHABLE" || state === "RESEARCHED") {
					buySound.play()
				}
				updateState()
			})
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	if (state === "RESEARCHABLE") {
		return (<>
			<div className='preview-bottom-menu' >
				<div className="preview-content-text">
					<div className='preview-content-text-amount'>
						<img src="/icons/32px/xp.png" alt="experience" />
						<p>{number}</p>
					</div>
				</div>

				<div className='preview-content-buttons'>
					<div
						className={`preview-content-button RESEARCH`}
						onClick={handleButtonClick}
					>
						{t.to_research}
					</div>
				</div>
			</div>
		</>)
	} else if (state === "BOUGHT") {
		return (<>
			<div className='preview-bottom-menu' >
				<div className='preview-content-buttons'>
					<div
						className={`preview-content-button AQUIRED`}
						onClick={handleButtonClick}
					>
						{t.show_in_garage}
					</div>
				</div>

				<div className="preview-content-text">
					<div className='preview-content-text-amount'>
						<img src="/icons/32px/xp.png" alt="experience" />
						<p>{number}</p>
					</div>
					<p>{t.race_experience}</p>
				</div>
			</div>
		</>)
	} else if (state === "RESEARCHED") {
		return (<>
			<div className='preview-bottom-menu' >
				<div className="preview-content-text">
					<div className='preview-content-text-amount'>
						<img src="/icons/32px/money.png" alt="money" />
						<p>{number}</p>
					</div>
				</div>

				<div className='preview-content-buttons'>
					<div
						className={`preview-content-button BUY`}
						onClick={handleButtonClick}
					>
						{t.buy}
					</div>
				</div>
			</div>
		</>)
	} else {
		return (<>
			<div className='preview-bottom-menu' />
		</>)
	}

}